export { default } from './GenderIcon';
export * from './types';
